/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, IconButton, Chip, FormControl, Checkbox, FormHelperText, Grid } from '@material-ui/core';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Service';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types'
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useTheme } from '@mui/material/styles';
import xlsx from 'json-as-xlsx';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';
import dayjs from 'dayjs';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

var screenCode = "SUPPLIERPAYMENTAUDITREPORT"

export default function SupplierPaymentAuditReport() {
    const componentRef = useRef();
    const navigate = useNavigate();
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Supplier Payment Audit Report'
    });
    const [fromDatevalue, setFromDateValue] = useState(new Date());
    const [toDatevalue, setToDateValue] = useState(new Date());
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [reportDetails, setReportDetails] = useState([]);
    const [isEnable, setIsEnable] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [grnData, setgrnData] = useState({
        grnName: ''
    });
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [formData, setFormData] = useState({
        groupID: '',
        operationEntityID: '',
        approveStatusID: '',
        paymentStatusID: '',
        fromDate: null,
        toDate: null
    });
    const [totalCals, setTotalCals] = useState(0);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: '',
        operationEntityName: '',
        fromDate: '',
        toDate: ''
    });
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedApproveStatus, setSelectedApproveStatus] = useState([]);
    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState([]);
    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const classes = useStyles();
    const supplierPaymentAuditReportSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.array()
            .min("1", 'Please select at least one Fresh collection center')
            .required('Please select at least one Fresh collection center'),
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            approveStatusID: selectedApproveStatus,
            paymentStatusID: selectedPaymentStatus,
            fromDate: fromDatevalue,
            toDate: toDatevalue,
        },

        validationSchema: supplierPaymentAuditReportSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
            setIsHidden(true)
        }
    });

    async function SubmitForm(values) {
        let model = {
            groupID: parseInt(values.groupID),
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            approveStatusID: selectedApproveStatus.map(x => x).join(',').toString(),
            paymentStatusID: selectedPaymentStatus.map(x => x).join(',').toString(),
            fromDate: new Date(fromDatevalue).toISOString(),
            toDate: new Date(toDatevalue).toISOString(),
        }

        let res = await services.GetSupplierPaymentAuditReport(model)

        const mergedData = [];
        const map = new Map();

        res.forEach(row => {
            const key = `${row.grnNumber}|${row.goodsReceiveDate}|${row.supplierCode}|${row.supplierName}|${row.isReinitiate}|${row.isActive}`;

            if (!map.has(key)) {
                map.set(key, { ...row });
            } else {
                const existing = map.get(key);
                existing.amount += row.amount;
            }
        });

        mergedData.push(...map.values());
        const total = mergedData.reduce((accumulator, current) => accumulator + current.amount, 0);
        mergedData.sort((a, b) => {
            const dateA = new Date(a.goodsReceiveDate);
            const dateB = new Date(b.goodsReceiveDate);
            return dateB - dateA;
        });
        mergedData.sort((a, b) => a.goodsReceiveDate > b.goodsReceiveDate ? 1 : -1);
        setTotalCals(total)
        setPage(0);
        setReportDetails(mergedData);
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        if (permissionList.isFactoryFilterEnabled) {
            setFromDateValue(new Date());
            setToDateValue(new Date());
            setValues({
                ...values,
                groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
                factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory),
                factoryID: '',
                approveStatusID: '',
                paymentStatusID: '',
                fromDatevalue: fromDatevalue.toISOString().split('T')[0],
                toDatevalue: toDatevalue.toISOString().split('T')[0],
            })
            setReportDetails([]);
            const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
            setSelectedOptions([factoryValue]);
            setSelectedApproveStatus([]);
            setSelectedPaymentStatus([]);
            setSelectedProductOptions([]);
        } else {
            setReportDetails([]);
        }
    }

    async function GetAllGroups() {
        let res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    function getSelectedDropdownValuesForReport() {
        var grpname
        {
            group.map((x) => (
                x.groupID == formik.values.groupID ? grpname = x.groupName : null
            ))
        }
        var operationentityname
        {
            factory.map((x) => (
                x.factoryID == formik.values.operationEntityID ? operationentityname = x.factoryName : null
            ))
        }
    }

    async function GetOperationEntityByGroupID() {
        let res = await services.GetVCCFactoriesByGroupID(formik.values.groupID);
        var newOptionArray = [];
        for (var i = 0; i < res.length; i++) {
            newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
        }
        setOperationEntityList(newOptionArray);
    }

    useEffect(() => {
        trackPromise(GetRouteByFactoryID());
    }, [formik.values.operationEntityID]);

    useEffect(() => {
    }, [formik.values.collectionCenterID]);

    useEffect(() => {
        getPermissions();
    }, [])

    useEffect(() => {
        GetAllGroups();
    }, []);
    useEffect(() => {
        setReportDetails([]);
    }, [formik.values.groupID, formik.values.operationEntityID, selectedApproveStatus, selectedPaymentStatus, formik.values.isReinitiate])

    useEffect(() => {
        setReportDetails([]);
    }, [fromDatevalue, toDatevalue]);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setReportDetails([]);
        setFromDateValue(new Date())
        setToDateValue(new Date())
    }, [selectedOptions, selectedProductOptions]);

    useEffect(() => {
        setSelectedOptions([]);
        setSelectedApproveStatus([]);
        setSelectedPaymentStatus([]);
        setFromDateValue(new Date())
        setToDateValue(new Date())
    }, [formik.values.groupID]);

    useEffect(() => {
        setValues({
            ...values,
            approveStatusID: '',
            paymentStatusID: '',
        });
    }, [formik.values.groupID, selectedOptions, toDatevalue, fromDatevalue]);


    useEffect(() => {
        setValues({
            ...values,
            isReinitiate: 0,
            paymentStatusID: 0,
        });
    }, [selectedApproveStatus]);

    useEffect(() => {
        setValues({
            ...values,
            isReinitiate: 0,
        });
    }, [selectedPaymentStatus]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions,
        })
    }, [selectedOptions, selectedProductOptions]);



    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [operationEntityList]);


    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - reportDetails.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSelectChange = (event) => {
        const selectedValues = event.target.value;
        if (selectedValues.includes('')) {
            setSelectedOptions(
                selectedOptions.length === operationEntityList.length
                    ? []
                    : operationEntityList.map((option) => option.value)
            );
        } else {
            setSelectedOptions(selectedValues);
        };
    };

    const handleApproveStatusChange = (event) => {
        const selectedValues = event.target.value;
        if (selectedValues.includes('')) {
            setSelectedApproveStatus(
                selectedApproveStatus.length === 9
                    ? []
                    : [1, 2, 3, 4, 5, 6, 7, 8, 9]
            );
        } else {
            setSelectedApproveStatus(selectedValues);
        }
    };

    const handlePaymentStatusChange = (event) => {
        const selectedValues = event.target.value;
        if (selectedValues.includes('')) {
            setSelectedPaymentStatus(
                selectedPaymentStatus.length === 2
                    ? []
                    : [1, 2]
            );
        } else {
            setSelectedPaymentStatus(selectedValues);
        }
    };

    const renderselectedApproveStatus = (selected) => {
        if (selected.length === 0) {
            return 'Select Options';
        } else if (selected.length === 1) {
            const option = [
                { value: 1, label: 'New' },
                { value: 2, label: 'FDC First Approved' },
                { value: 3, label: 'FDC Second Approved' },
                { value: 4, label: 'Finance First Approved' },
                { value: 5, label: 'Finance Second Approved' },
                { value: 6, label: 'FDC First Rejected' },
                { value: 7, label: 'FDC Second Rejected' },
                { value: 8, label: 'Finance First Rejected' },
                { value: 9, label: 'Finance Second Rejected' }
            ].find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                const option = [
                    { value: 1, label: 'New' },
                    { value: 2, label: 'FDC First Approved' },
                    { value: 3, label: 'FDC Second Approved' },
                    { value: 4, label: 'Finance First Approved' },
                    { value: 5, label: 'Finance Second Approved' },
                    { value: 6, label: 'FDC First Rejected' },
                    { value: 7, label: 'FDC Second Rejected' },
                    { value: 8, label: 'Finance First Rejected' },
                    { value: 9, label: 'Finance Second Rejected' }
                ].find((entity) => entity.value === value);
                return option ? <Chip key={index} label={option.label} /> : null;
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderPaymentStatusChange = (selected) => {
        if (selected.length === 0) {
            return 'Select Options';
        } else if (selected.length === 1) {
            const option = [
                { value: 1, label: 'Payment Reinitiate Screen' },
                { value: 2, label: 'GRN Summary Approval Screen' },
            ].find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                const option = [
                    { value: 1, label: 'Payment Reinitiate Screen' },
                    { value: 2, label: 'GRN Summary Approval Screen' },
                ].find((entity) => entity.value === value);
                return option ? <Chip key={index} label={option.label} /> : null;
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
    };

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSUPPLIERPAYMENTAUDITREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
    }

    async function GetRouteByFactoryID() {
        var res = await services.GetRouteByFactoryID(formik.values.operationEntityID)
        if (res != null) {
            setRoute(res);
        }
    }

    async function createFile() {
        var file = await createDataForExcel(reportDetails);

        var settings = {
            sheetName: 'SP Audit Report',
            fileName: 'Supplier Payment Audit Report',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'SP Audit Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.forEach(x => {
                var vr = {
                    'GRN Number': x.grnNumber ?? '-',
                    'GRN Date': x.goodsReceiveDate ? moment(new Date(x.goodsReceiveDate)).format("YYYY-MM-DD") : '-',
                    'Supplier Code': x.supplierCode ?? '-',
                    'Supplier Name': x.supplierName ?? '-',
                    'GRN Amount': x.amount !== undefined && x.amount !== null ? parseFloat(x.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
                    'Payment screen': (x.isReinitiate === true && x.isActive === true)
                        ? "Payment Reinitiate Screen"
                        : "GRN Summary Approval Screen",
                    'Payment Approval status':
                        x.approvalStatus == 1 ? "New"
                            : x.approvalStatus == 2 ? "FDC First Approved"
                                : x.approvalStatus == 3 ? "FDC Second Approved"
                                    : x.approvalStatus == 4 ? "Finance First Approved"
                                        : x.approvalStatus == 5 ? "Finance Second Approved"
                                            : x.approvalStatus == 6 ? "FDC First Rejected"
                                                : x.approvalStatus == 7 ? "FDC Second Rejected"
                                                    : x.approvalStatus == 8 ? "Finance First Rejected"
                                                        : x.approvalStatus == 9 ? "Finance Second Rejected"
                                                            : "Active",
                    'FDC 1st Approver': x.fdcFirst ?? '-',
                    'FDC 1st Approval Date': x.fdcUserTime ? moment(x.fdcUserTime).format('YYYY-MM-DD HH:mm') : '-',
                    'FDC 2nd Approver': x.fdcSec ?? '-',
                    'FDC 2nd Approval Date': x.fdcApproverUserTime ? moment(x.fdcApproverUserTime).format('YYYY-MM-DD HH:mm') : '-',
                    'Finance 1st Approver': x.financeFirst ?? '-',
                    'Finance 1st Approval Date': x.financeApprover1UserTime ? moment(x.financeApprover1UserTime).format('YYYY-MM-DD HH:mm') : '-',
                    'Finance 2nd Approver': x.financeSec ?? '-',
                    'Finance 2nd Approval Date': x.financeApprover2UserTime ? moment(x.financeApprover2UserTime).format('YYYY-MM-DD HH:mm') : '-'
                }
                res.push(vr);
            });
            var vr2 = {
                'GRN Number': 'Total',
                'GRN Amount': parseFloat(totalCals).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            }
            res.push(vr2);
        }
        return res;
    }


    function getSelectedDropdownValuesForReport() {
        let groups = groupList.find(x => x.groupID == formik.values.groupID)
        const facName = [];
        const proName = [];
        selectedOptions.forEach(x => {
            const fildered = operationEntityList.find(y => x === y.value).label
            facName.push(fildered)
        });
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupName: groups.groupName,
            operationEntityName: facName.length == 0 ? 'All Fresh Collection Centers' : facName.join(','),
            fromDate: new Date(fromDatevalue).toISOString().split('T')[0],
            toDate: new Date(toDatevalue).toISOString().split('T')[0],
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return 'Select Options';
        } else if (selected.length === 1) {
            const option = operationEntityList.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Supplier Payment Audit Report  |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Group *"
                                                value={formik.values.groupID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('groupID')}
                                                error={Boolean(touched.groupID && errors.groupID)}
                                                helperText={touched.groupID && errors.groupID}
                                                InputProps={{
                                                    readOnly: !permissionList.isGroupFilterEnabled
                                                }}
                                            >
                                                <MenuItem key={0} value={0}>Select Group</MenuItem>
                                                {groupList.map((option) => (
                                                    option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                        {option.groupName}
                                                    </MenuItem> : null
                                                ))}
                                            </TextField>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                                <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                                <Select
                                                    className="custom-select"
                                                    labelId="multi-select-label"
                                                    id="multi-select"
                                                    multiple
                                                    size="small"
                                                    value={selectedOptions}
                                                    onChange={handleSelectChange}
                                                    label="Fresh Collection Center "
                                                    disabled={!permissionList.isFactoryFilterEnabled}
                                                    renderValue={(selected) => renderSelectedValue(selected)}
                                                >
                                                    <MenuItem key={0} value={''}>
                                                        <Checkbox checked={selectedOptions.length === operationEntityList.length} color="primary" />
                                                        All Fresh Collection Center
                                                    </MenuItem>
                                                    {operationEntityList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                {touched.operationEntityID && errors.operationEntityID && (
                                                    <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                                )}
                                                {selectedOptions.length > 0 && (
                                                    <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                        {!permissionList.isFactoryFilterEnabled ? null :
                                                            <ClearIcon />}
                                                    </IconButton>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    fullWidth
                                                    size="small"
                                                    label="GRN Complete From Date *"
                                                    openTo="day"
                                                    type="date"
                                                    inputFormat="MM/DD/YYYY"
                                                    value={fromDatevalue}
                                                    onChange={(newValue) => {
                                                        setFromDateValue(newValue);
                                                    }}
                                                    maxDate={dayjs()}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            {...params}
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    fullWidth
                                                    size="small"
                                                    label="GRN Complete To Date *"
                                                    openTo="day"
                                                    type="date"
                                                    inputFormat="MM/DD/YYYY"
                                                    value={toDatevalue}
                                                    onChange={(newValue) => {
                                                        setToDateValue(newValue);
                                                    }}
                                                    maxDate={dayjs()}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            {...params}
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <FormControl fullWidth error={Boolean(touched.approveStatusID && errors.approveStatusID)}>
                                                <InputLabel id="approve-status-label">Approve Status</InputLabel>
                                                <Select
                                                    className='custom-select'
                                                    labelId="approve-status-label"
                                                    id="approve-status-select"
                                                    multiple
                                                    size="small"
                                                    label="Approve Status"
                                                    value={selectedApproveStatus}
                                                    onChange={handleApproveStatusChange}
                                                    renderValue={(selected) => renderselectedApproveStatus(selected)}
                                                >
                                                    <MenuItem key={0} value={''}>
                                                        <Checkbox checked={selectedApproveStatus.length === 9} color="primary" />
                                                        All Status
                                                    </MenuItem>
                                                    <MenuItem value={1}>
                                                        <Checkbox checked={selectedApproveStatus.indexOf(1) > -1} color="primary" />
                                                        New
                                                    </MenuItem>
                                                    <MenuItem value={2}>
                                                        <Checkbox checked={selectedApproveStatus.indexOf(2) > -1} color="primary" />
                                                        FDC First Approved
                                                    </MenuItem>
                                                    <MenuItem value={3}>
                                                        <Checkbox checked={selectedApproveStatus.indexOf(3) > -1} color="primary" />
                                                        FDC Second Approved
                                                    </MenuItem>
                                                    <MenuItem value={4}>
                                                        <Checkbox checked={selectedApproveStatus.indexOf(4) > -1} color="primary" />
                                                        Finance First Approved
                                                    </MenuItem>
                                                    <MenuItem value={5}>
                                                        <Checkbox checked={selectedApproveStatus.indexOf(5) > -1} color="primary" />
                                                        Finance Second Approved
                                                    </MenuItem>
                                                    <MenuItem value={6}>
                                                        <Checkbox checked={selectedApproveStatus.indexOf(6) > -1} color="primary" />
                                                        FDC First Rejected
                                                    </MenuItem>
                                                    <MenuItem value={7}>
                                                        <Checkbox checked={selectedApproveStatus.indexOf(7) > -1} color="primary" />
                                                        FDC Second Rejected
                                                    </MenuItem>
                                                    <MenuItem value={8}>
                                                        <Checkbox checked={selectedApproveStatus.indexOf(8) > -1} color="primary" />
                                                        Finance First Rejected
                                                    </MenuItem>
                                                    <MenuItem value={9}>
                                                        <Checkbox checked={selectedApproveStatus.indexOf(9) > -1} color="primary" />
                                                        Finance Second Rejected
                                                    </MenuItem>
                                                </Select>
                                                {touched.approveStatusID && errors.approveStatusID && (
                                                    <FormHelperText>{errors.approveStatusID}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <FormControl fullWidth error={Boolean(touched.paymentStatusID && errors.paymentStatusID)}>
                                                <InputLabel id="payment-status-label">Payment screen</InputLabel>
                                                <Select
                                                    className="custom-select"
                                                    labelId="payment-status-label"
                                                    id="payment-status-select"
                                                    multiple
                                                    size="small"
                                                    label="Payment screen"
                                                    value={selectedPaymentStatus}
                                                    onChange={handlePaymentStatusChange}
                                                    renderValue={(selected) => renderPaymentStatusChange(selected)}
                                                >
                                                    <MenuItem key={0} value={''}>
                                                        <Checkbox checked={selectedPaymentStatus.length === 2} color="primary" />
                                                        All Status
                                                    </MenuItem>
                                                    <MenuItem value={1}>
                                                        <Checkbox checked={selectedPaymentStatus.indexOf(1) > -1} color="primary" />
                                                        Payment Reinitiate Screen
                                                    </MenuItem>
                                                    <MenuItem value={2}>
                                                        <Checkbox checked={selectedPaymentStatus.indexOf(2) > -1} color="primary" />
                                                        GRN Summary Approval Screen
                                                    </MenuItem>
                                                </Select>
                                                {touched.paymentStatusID && errors.paymentStatusID && (
                                                    <FormHelperText>{errors.paymentStatusID}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color="error"
                                                onClick={() => clearAll()}
                                                style={{ marginRight: '10px' }} // Added marginRight for spacing
                                            >
                                                Clear
                                            </Button>
                                            <Button
                                                type="submit"
                                                color="secondary"
                                                variant="outlined"
                                            >
                                                Search
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Stack>
                            </Stack>
                            <br />
                            {isEnable == false ?
                                <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginBottom: '10px' }} justifyContent="right" spacing={2}>
                                    <TextField
                                        size="small"
                                        style={{ width: '300px' }}
                                        value={grnData.grnName}
                                        placeholder="Search"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Stack> : null}
                            {reportDetails.length != 0 ?
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Card style={{ justifycontent: 'center', width: '120rem' }} >
                                        <TableContainer component={Paper} >
                                            <Table aria-label="simple table" size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>GRN Number</TableCell>
                                                        <TableCell align='left' style={{ whiteSpace: "nowrap" }}>GRN Date</TableCell>
                                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Supplier Code</TableCell>
                                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Supplier Name</TableCell>
                                                        <TableCell align="right" style={{ whiteSpace: "nowrap" }}>GRN Amount</TableCell>
                                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Payment Screen</TableCell>
                                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Payment Approval Status</TableCell>
                                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>FDC 1st Approver</TableCell>
                                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>FDC 1st Approval Date Time</TableCell>
                                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>FDC 2nd Approver</TableCell>
                                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>FDC 2nd Approval Date Time</TableCell>
                                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Finance 1st Approver</TableCell>
                                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Finance 1st Approval Date Time</TableCell>
                                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Finance 2nd Approver</TableCell>
                                                        <TableCell align="left" style={{ whiteSpace: "nowrap" }}>Finance 2nd Approval Date Time</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {(rowsPerPage > 0
                                                        ? reportDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                        : reportDetails
                                                    ).map((row, i) => {
                                                        return (
                                                            <TableRow key={i}>
                                                                <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.grnNumber}</TableCell>
                                                                <TableCell align="left" style={{ whiteSpace: "nowrap" }}>
                                                                    {row.goodsReceiveDate ? moment(new Date(row.goodsReceiveDate)).format('MM/DD/YYYY') : '-'}
                                                                </TableCell>
                                                                <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.supplierCode}</TableCell>
                                                                <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.supplierName}</TableCell>
                                                                <TableCell align="right" style={{ whiteSpace: "nowrap" }}>{parseFloat(row.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                <TableCell align="left" style={{ whiteSpace: "nowrap" }}>
                                                                    {row.isReinitiate == true && row.isActive == true
                                                                        ? <Chip size="small" label="Payment Reinitiate Screen" style={{ color: 'black' }} />
                                                                        : <Chip size="small" label="GRN Summary Approval Screen" style={{ color: 'black' }} />}
                                                                </TableCell>
                                                                <TableCell align="left" style={{ whiteSpace: "nowrap" }}>
                                                                    {row.approvalStatus == 1 ? <Chip size="small" label="New" style={{ color: 'green' }} />
                                                                        : row.approvalStatus == 2 ? <Chip size="small" label="FDC First Approved" style={{ color: 'orange' }} />
                                                                            : row.approvalStatus == 3 ? <Chip size="small" label="FDC Second Approved" style={{ color: '#B414F9' }} />
                                                                                : row.approvalStatus == 4 ? <Chip size="small" label="Finance First Approved" style={{ color: 'blue' }} />
                                                                                    : row.approvalStatus == 5 ? <Chip size="small" label="Finance Second Approved" style={{ color: 'blue' }} />
                                                                                        : row.approvalStatus == 6 ? <Chip size="small" label="FDC First Rejected" style={{ color: 'red' }} />
                                                                                            : row.approvalStatus == 7 ? <Chip size="small" label="FDC Second Rejected" style={{ color: 'red' }} />
                                                                                                : row.approvalStatus == 8 ? <Chip size="small" label="Finance First Rejected" style={{ color: 'red' }} />
                                                                                                    : row.approvalStatus == 9 ? <Chip size="small" label="Finance Second Rejected" style={{ color: 'red' }} />
                                                                                                        : <Chip size="small" label="Active" style={{ color: 'green' }} />}
                                                                </TableCell>
                                                                <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.fdcFirst}</TableCell>
                                                                <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.fdcUserTime ? moment(row.fdcUserTime).format('MM/DD/YYYY HH:mm') : '-'}</TableCell>
                                                                <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.fdcSec}</TableCell>
                                                                <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.fdcApproverUserTime ? moment(row.fdcApproverUserTime).format('MM/DD/YYYY HH:mm') : '-'}</TableCell>
                                                                <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.financeFirst}</TableCell>
                                                                <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.financeApprover1UserTime ? moment(row.financeApprover1UserTime).format('MM/DD/YYYY HH:mm') : '-'}</TableCell>
                                                                <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.financeSec}</TableCell>
                                                                <TableCell align="left" style={{ whiteSpace: "nowrap" }}>{row.financeApprover2UserTime ? moment(row.financeApprover2UserTime).format('MM/DD/YYYY HH:mm') : '-'}</TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                    {emptyRows > 0 && (
                                                        <TableRow style={{ height: 53 * emptyRows }}>
                                                            <TableCell colSpan={20} />
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                                <TableRow>
                                                    <TableCell align="left" colSpan={4}><b>Total</b></TableCell>
                                                    <TableCell align="right"><b>{parseFloat(totalCals).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                                                    <TableCell colSpan={10} />
                                                </TableRow>
                                            </Table>
                                        </TableContainer>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                            count={reportDetails.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            SelectProps={{
                                                inputProps: {
                                                    'aria-label': 'rows per page',
                                                },
                                                native: true,
                                            }}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            ActionsComponent={TablePaginationActions}
                                        />
                                    </Card>
                                </Stack> : <SearchNotFound searchQuery="Supplier Payment Audit Report" />}
                        </Form>
                    </FormikProvider>
                    {reportDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Supplier Payment Verification Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    reportDetails={reportDetails}
                                    searchData={selectedSearchValues}
                                    totalCals={totalCals}
                                />
                            </div>
                        </Box>
                        : null}
                </Container>
            </Page>
        </>
    );
}
